import { Box, useTheme } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { Button } from '@mui/material'
import { tokens } from '../../theme'
import Header from '../../components/Header'
import React from "react"
import { useState, useEffect } from "react"
import { ptBR as ptBRGrid } from '@mui/x-data-grid'
import { useNavigate } from 'react-router-dom'

import * as Constants from '../../constants'

const Whitelist = () => {
  const theme = useTheme()
  const colors = tokens(theme.palette.mode)

  const [rows, setRows] = useState([])

  const fetchWhitelist = () => {
    fetch(Constants.HOST + '/getWhitelist', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        token: JSON.parse(localStorage.getItem('user_data')).token,
      }),
    })
      .then((response) => {
        if (response.status === 200) {
          response.json().then((data) => {
            data = data.data
            let newRows = []

            if (typeof data.whitelist === 'object') {
              data.whitelist.forEach((app) => {
                newRows.push({
                  id: app.id,
                  package: app.package_name,
                })
              })
            }
            setRows(newRows)
          })
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const updateWhitelist = () => {
    fetch(Constants.HOST + '/updateWhitelist', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        token: JSON.parse(localStorage.getItem('user_data')).token,
      }),
    })
  }

  useEffect(() => {
    fetchWhitelist()
  }, [])

  const columns = [
    {
      field: 'package',
      headerName: 'Nome do pacote',
      flex: 1,
      cellClassName: 'name-column--cell',
    },
    {
      field: 'actions',
      headerName: '',
      renderCell: ({ row: { id } }) => {
        return (
          <Box display="flex" justifyContent="right">
            <Button
              variant="contained"
              onClick={() => navigate(`/del-whitelist/${id}`)}
            >
              {' '}
              Excluir{' '}
            </Button>
          </Box>
        )
      },
    },
  ]

  let navigate = useNavigate()
  const handleAddApp = () => {
    navigate('/add-whitelist')
  }

  return (
    <Box m="20px">
      <Box mb="20px" display="flex" justifyContent="space-between">
        <Box display="grid" gridColumn="span 6" justifyContent="space-between">
          <Header
            title="Lista branca"
            subtitle="Apps permitidos nos dispositivos"
          />
        </Box>
        <Box
          m="20px 0"
          display="grid"
          gridColumn="span 6"
          justifyContent="flex-end"
        ></Box>
        <Box
          m="20px 0"
          gridColumn="span 6"
          justifyContent="flex-end"
          display={{ xs: 'none', md: 'flex' }}
        >
          <Button
            variant="contained"
            color="warning"
            onClick={updateWhitelist}
            sx={{ mr: '5px' }}
          >
            Atualizar lista branca em dispositivos conectados
          </Button>
          <Button variant="contained" color="success" onClick={handleAddApp}>
            Adicionar app
          </Button>
        </Box>
      </Box>
      <Box
        m="20px 0 0 0"
        height="75vh"
        sx={{
          '& .MuiDataGrid-root': {
            border: 'none',
          },
          '& .MuiDataGrid-cell': {
            borderBottom: 'none',
          },
          '& .name-column--cell': {
            color: colors.greenAccent[300],
          },
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: colors.blueAccent[700],
            borderBottom: 'none',
          },
          '& .MuiDataGrid-virtualScroller': {
            backgroundColor: colors.primary[400],
          },
          '& .MuiDataGrid-footerContainer': {
            borderTop: 'none',
            backgroundColor: colors.blueAccent[700],
          },
          '& .MuiCheckbox-root': {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        <DataGrid
          rows={rows}
          columns={columns}
          localeText={ptBRGrid.components.MuiDataGrid.defaultProps.localeText}
        />
      </Box>
    </Box>
  )
}

export default Whitelist
